__turbopack_context__.v({
  "container": "OMfSDa_container",
  "isBouncing": "OMfSDa_isBouncing",
});
